import React, { useEffect, useState, useMemo } from "react";
import ReactPixel from "react-facebook-pixel";
import TagManager from "react-gtm-module";
import { useForm } from "react-hook-form";
import DateTimeComponent from "../../DateTimeComponent";
import DateTimePickerComponent from "../../DateTimePickerComponent";
import {
  arrow_rounded,
  // dashboard_car_yellow_icon,
  dashboard_special_deal,
  // dashboard_calendar_yellow_icon,
  // dashboard_customer_arrow,
  // dashboard_location_yellow_icon,
  group_icon,
  carousel_image_one,
  // mileage,
  noun_no_image,
  petrol_pump,
  vector,
} from "../../../assets/images";
import {
  StarFill,
  PencilSquare,
  Tools,
  FunnelFill,
  Funnel,
  ArrowCounterclockwise,
} from "react-bootstrap-icons";
import { Carousel, Modal, OverlayTrigger, Tooltip, Offcanvas } from "react-bootstrap";
import CustomerCustomizeYourSearch from "../CustomerCustomizeYourSearch";
import { useMutation, useQuery } from "@tanstack/react-query";
import { trackEvent } from "../../../services/events";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import {
  bookingData,
  CustomerDetails,
  ProductSearch,
  searchResult,
} from "../../../types";
import { useNavigate, useLocation } from "react-router-dom";
import MerchantDashboardReviews from "../../MerchantDashboard/MerchantDashboardReviews";
import FloatingInputLocation from "../../FloatingInputLocation";
import LocationPickerModal from "../../LocationPickerModal"; // Import Modal
import { toast } from "react-toastify";

// import TimePicker from "../../TimePicker/components/TimePicker";
import moment from "moment";
import CustomerDashBoardHowItWorks from "../CustomerDashBoardHowItWorks";
import TimePickerComponent from "../../TimePickerComponent";
import PageLoader from "../../Loader/PageLoader";
import { clearBookingValues } from "../../../Redux/BookingData/bookingDataSlice";
import { useDispatch } from "react-redux";
// import { DatePicker } from "@capacitor-community/date-picker";
// import MobileTimePickerComponent from "../../TimePickerComponent/MobileTimePicker";

interface Location {
  latitude: number | null;
  longitude: number | null;
}
interface FieldErrors {
  pickupDate?: string;
  dropOffDate?: string;
  pickupTime?: string;
  dropOffTime?: string;
  pickupLocation?: string;
  returnLocation?: string;
}

const mobileFilterStyles = `
  .home-mobile-filter-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.25rem;
    background: rgba(240, 182, 79, 0.1);
    border: 1px solid rgba(240, 182, 79, 0.35);
    border-radius: 12px;
    color: #f1c260;
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 0.88rem;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    transition: all 0.2s ease;
  }
  .home-results-count-pill {
    background: #000;
    color: #F0B64F;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    margin-left: 0.35rem;
  }
  .home-results-chip {
    display: inline-flex;
    align-items: center;
    padding: 0.35rem 0.75rem;
    border-radius: 8px;
    background: rgba(240, 182, 79, 0.08);
    border: 1px solid rgba(240, 182, 79, 0.15);
    color: #f0b64f;
    font-family: "Poppins", sans-serif;
    font-size: 0.75rem;
    font-weight: 700;
    transition: all 0.2s;
    cursor: pointer;
    margin-right: 8px;
    margin-bottom: 8px;
  }
  .home-filter-drawer {
    background-color: #12151c !important;
  }
  .home-filter-drawer .offcanvas-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    padding: 1.25rem;
    flex-shrink: 0;
  }
  .home-filter-drawer .offcanvas-body {
    overflow-y: auto;
    flex-grow: 1;
  }
  .home-filter-drawer {
    display: flex;
    flex-direction: column;
    overflow: hidden !important;
  }
  .home-results-applied {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 0;
    margin-top: 0.5rem;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
  }
  .home-results-applied__label {
    color: rgba(255, 255, 255, 0.4);
    font-family: Poppins, sans-serif;
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
  }
  .home-results-applied__list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    align-items: center;
  }
  .mobile-search-card {
    margin: 0 !important;
    border-radius: 16px !important;
    border: 1px solid rgba(240, 182, 79, 0.2) !important;
  }
  .mobile-search-card .row.g-4 {
    --bs-gutter-y: 0.75rem !important;
    --bs-gutter-x: 0.75rem !important;
  }
`;

const CustomerDashBoardMyAccount = () => {
  const [customizeResult, setCustomizeResult] = useState<any>(null);

  const [pickupLocation, setPickupLocation] = useState<Location>({
    latitude: null,
    longitude: null,
  });
  const navigate = useNavigate();
  const location = useLocation();
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [showCreateProduct, setShowCreateProduct] = useState(false);
  const accessToken = localStorage.getItem("access_token");
  const [returnLocation, setReturnLocation] = useState<Location>({
    latitude: null,
    longitude: null,
  });
  const [pickupDate, setPickupDate] = useState<string | Date>("");
  const [dropOffDate, setDropOffDate] = useState<string | Date>("");
  const [searchCars, SetSearchCars] = useState<any>([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [searchResultHeading, setSearchResultHeading] = useState(false);
  const [selectedDropTime, setSelectedDropTime] = useState("");
  const [isSameDate, setIsSameDate] = useState<boolean>(false);
  const [searchValues, setSearchValues] = useState<any>({
    pickup: "",
    return: "",
  });
  const [returnToSameLocation, setReturnToSameLocation] = useState(true); // Default to ON as requested
  const [showPickupMapModal, setShowPickupMapModal] = useState(false);
  const [showReturnMapModal, setShowReturnMapModal] = useState(false);

  // Add these after other state declarations
  const [pickupTimeError, setPickupTimeError] = useState<string>("");
  const [dropOffTimeError, setDropOffTimeError] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMobileView, setIsMobileView] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [upgradeData, setUpgradeData] = useState<any>(null);
  const [selectProductId, setSelectProductId] = useState<string>("");
  const [merchantId1, setMerchantId1] = useState<string>("");
  const [fieldErrors, setFieldErrors] = useState<FieldErrors>({});
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [isLoadingCurrentLocation, setIsLoadingCurrentLocation] =
    useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [carName, setCarName] = useState("");
  const [isRotating, setIsRotating] = useState(false);

  const dispatch = useDispatch();

  const {
    control,
  } = useForm({
    mode: "onChange",
  });
  let searchResultData: searchResult[] = [];

  const normalizeFilterValue = (value: any) =>
    String(value ?? "").trim().toLowerCase();

  const filterCatalog = useMemo(() => {
    const cars = Array.isArray(searchCars) ? searchCars : [];
    const priceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_day))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const weeklyPriceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_week))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const monthlyPriceValues = cars
      .map((car: any) => Number(car?.product_details_car?.price_per_month))
      .filter((price: number) => Number.isFinite(price) && price > 0);

    const uniqueSorted = (values: string[]) =>
      Array.from(new Set(values.filter(Boolean))).sort((a, b) =>
        a.localeCompare(b),
      );

    return {
      minPrice: priceValues.length ? Math.min(...priceValues) : 0,
      maxPrice: priceValues.length ? Math.max(...priceValues) : 0,
      minWeeklyPrice: weeklyPriceValues.length ? Math.min(...weeklyPriceValues) : 0,
      maxWeeklyPrice: weeklyPriceValues.length ? Math.max(...weeklyPriceValues) : 0,
      minMonthlyPrice: monthlyPriceValues.length ? Math.min(...monthlyPriceValues) : 0,
      maxMonthlyPrice: monthlyPriceValues.length ? Math.max(...monthlyPriceValues) : 0,
      carTypes: uniqueSorted(
        cars.map((car: any) =>
          car?.product_details_car?.car_type || car?.product_details_car?.category || "",
        ),
      ),
      brands: uniqueSorted(
        cars.map((car: any) =>
          car?.product_details_car?.car_brand ||
          car?.brand ||
          car?.product_name ||
          "",
        ),
      ),
      fuelTypes: uniqueSorted(
        cars.map((car: any) => car?.product_details_car?.fuel_type || ""),
      ),
      transmissions: uniqueSorted(
        cars.map((car: any) => car?.product_details_car?.transmission || ""),
      ),
    };
  }, [searchCars]);

  const filteredCars = useMemo(() => {
    const cars = Array.isArray(searchCars) ? searchCars : [];
    if (!customizeResult) return cars;

    const {
      priceRange,
      weeklyPriceRange,
      monthlyPriceRange,
      selectedCarTypes = [],
      selectedBrands = [],
      selectedFuelTypes = [],
      selectedTransmissions = [],
      isUnlimitedMileage,
      seat_capacity,
      mileage,
    } = customizeResult;

    return cars.filter((car: any) => {
      const details = car?.product_details_car || {};
      const carPrice = Number(details.price_per_day) || 0;
      const weeklyPrice = Number(details.price_per_week) || 0;
      const monthlyPrice = Number(details.price_per_month) || 0;
      const carType = normalizeFilterValue(details.car_type || details.category);
      const carBrand = normalizeFilterValue(details.car_brand || car.brand || car.product_name || details.car_model);
      const fuelType = normalizeFilterValue(details.fuel_type);
      const transmission = normalizeFilterValue(details.transmission);
      const seats = Number(details.number_of_seats) || 0;
      const dailyMileage = details.mileage?.daily_mileage;

      // Price filter (Daily)
      if (priceRange && (priceRange.min > 0 || priceRange.max > 0)) {
        if (priceRange.min > 0 && carPrice < priceRange.min) return false;
        if (priceRange.max > 0 && carPrice > priceRange.max) return false;
      } else if (customizeResult.amount_range > 0 && carPrice > customizeResult.amount_range) {
        return false;
      }

      // Weekly Price Filter
      if (weeklyPriceRange && weeklyPriceRange.max > 0) {
        if (weeklyPrice < weeklyPriceRange.min || weeklyPrice > weeklyPriceRange.max) return false;
      }

      // Monthly Price Filter
      if (monthlyPriceRange && monthlyPriceRange.max > 0) {
        if (monthlyPrice < monthlyPriceRange.min || monthlyPrice > monthlyPriceRange.max) return false;
      }

      // Multi-select filters
      if (selectedCarTypes.length > 0 && !selectedCarTypes.map(normalizeFilterValue).includes(carType)) return false;
      if (selectedBrands.length > 0 && !selectedBrands.map(normalizeFilterValue).includes(carBrand)) return false;
      if (selectedFuelTypes.length > 0 && !selectedFuelTypes.map(normalizeFilterValue).includes(fuelType)) return false;
      if (selectedTransmissions.length > 0 && !selectedTransmissions.map(normalizeFilterValue).includes(transmission)) return false;

      // Unlimited mileage filter
      if (isUnlimitedMileage && dailyMileage) return false;

      // Seat capacity filter
      if (seat_capacity && Array.isArray(seat_capacity) && seat_capacity.length > 0) {
        if (!seat_capacity.includes(seats)) return false;
      } else if (seat_capacity > 0 && seats !== Number(seat_capacity)) {
        // Fallback for legacy single-value seat_capacity
        return false;
      }

      // Daily mileage (legacy numeric)
      if (mileage && !isUnlimitedMileage && dailyMileage && Number(dailyMileage) < Number(mileage)) return false;

      return true;
    });
  }, [searchCars, customizeResult]);

  // const handleDropOffTimeChange = (newTime: any) => {
  //   console.log("Selected time:", newTime);
  //   setSelectedDropTime(newTime);
  // };

  // const handleTimeChange = (time: any) => {
  //   setSelectedTime(time);
  // };

  useEffect(() => {
    let searchData: any | null = null;

    if (location.state?.searchData) {
      searchData = location.state.searchData;
    } else {
      try {
        const stored = sessionStorage.getItem("customerDashboardSearchData");
        if (stored) {
          searchData = JSON.parse(stored);
        } else {
          // Fallback to localStorage for persistent location history across sessions
          const persistent = localStorage.getItem("lastSavedSearchLocation");
          if (persistent) {
            const parsed = JSON.parse(persistent);
            // Only load location and toggle data from persistent storage to preserve fresh default dates
            searchData = {
              pickupPlace: parsed.pickupPlace,
              returnPlace: parsed.returnPlace,
              pickupLocLatitude: parsed.pickupLocLatitude,
              pickupLocLongitude: parsed.pickupLocLongitude,
              returnLocLatitude: parsed.returnLocLatitude,
              returnLocLongitude: parsed.returnLocLongitude,
              returnToSameLocation: parsed.returnToSameLocation,
            };
          }
        }
      } catch (error) {
        console.error("Failed to read search data from storage", error);
      }
    }

    if (searchData) {
      if (typeof searchData.returnToSameLocation === "boolean") {
        setReturnToSameLocation(searchData.returnToSameLocation);
      }
      setSearchValues({
        pickup: searchData.pickupPlace || "",
        return: searchData.returnPlace || "",
      });
      if (searchData.pickupLocLatitude && searchData.pickupLocLongitude) {
        setPickupLocation({
          latitude: parseFloat(searchData.pickupLocLatitude),
          longitude: parseFloat(searchData.pickupLocLongitude),
        });
      }
      if (searchData.returnLocLatitude && searchData.returnLocLongitude) {
        setReturnLocation({
          latitude: parseFloat(searchData.returnLocLatitude),
          longitude: parseFloat(searchData.returnLocLongitude),
        });
      }
      if (searchData.pickupDate) {
        const d = new Date(searchData.pickupDate);
        if (!Number.isNaN(d.getTime())) {
          setPickupDate(d as any);
        }
      }
      if (searchData.product_name) {
        setCarName(searchData.product_name);
      }
      if (searchData.dropOffDate) {
        const d = new Date(searchData.dropOffDate);
        if (!Number.isNaN(d.getTime())) {
          setDropOffDate(d as any);
        }
      }
      if (searchData.selectedTime) {
        setSelectedTime(searchData.selectedTime);
      }
      if (searchData.selectedDropTime) {
        setSelectedDropTime(searchData.selectedDropTime);
      }
      if (searchData.customizeResult) {
        setCustomizeResult(searchData.customizeResult);
      }
      setFieldErrors({});
    }
  }, [location.state]);

  useEffect(() => {
    const checkMobile = () => {
      const isSmall = window.innerWidth <= 1024;
      setIsMobileView(isSmall);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const trackPageLoad = async () => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("ViewContent", {
        content_type: "page",
        content_name: "Customer Dashboard",
        content_category: "Dashboard",
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_DashboardScreen",
          app: "Kirkos_DashboardScreen_App",
        },
        event_category: "Dashboard_Info",
        module: "Dashboard",
        payload: {},
      });
    };
    trackPageLoad();

    const searchSection = document.querySelector(".custom-myAccount-card");
    if (searchSection) {
      searchSection.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  useEffect(() => {
    if (!pickupDate) {
      setPickupTimeError("");
      return;
    }

    const timeToValidate = selectedTime || "09:00";

    setFieldErrors((prev) => ({ ...prev, pickupTime: undefined }));
    const selectedDate = new Date(pickupDate);
    const today = new Date();
    const currentHour = today.getHours();
    const currentMinutes = today.getMinutes();
    const minimumTime = new Date(today.getTime() + 2 * 60 * 60 * 1000);
    const [hours, minutes] = timeToValidate.split(":").map(Number);
    const isToday =
      selectedDate.getDate() === today.getDate() &&
      selectedDate.getMonth() === today.getMonth() &&
      selectedDate.getFullYear() === today.getFullYear();

    const isNoServiceToday =
      isToday && currentHour * 60 + currentMinutes + 120 >= 22 * 60;

    if (isNoServiceToday) {
      setPickupTimeError(
        "* No service available for today. Please select tomorrow's date",
      );
    } else if (isToday) {
      // Explicit "Today" Time Validation Logic
      const currentTotalMinutes = currentHour * 60 + currentMinutes;
      const selectedTotalMinutes = hours * 60 + minutes;
      const minimumTotalMinutes = currentTotalMinutes + 120;

      if (minimumTotalMinutes >= 22 * 60) {
        setPickupTimeError("* No service available for today.");
      } else if (
        selectedTotalMinutes < minimumTotalMinutes ||
        !(hours < 22 || (hours === 22 && minutes === 0))
      ) {
        const minHour = minimumTime.getHours();
        const minMinute = minimumTime.getMinutes();
        setPickupTimeError(
          `* Today services are available between ${String(minHour).padStart(
            2,
            "0",
          )}:${String(minMinute).padStart(2, "0")} to 22:00`,
        );
      } else {
        setPickupTimeError("");
      }
    } else {
      // Future Date - Standard Validation
      if (!((hours === 22 && minutes === 0) || (hours >= 9 && hours < 22))) {
        setPickupTimeError("* Services available between 09:00 to 22:00");
      } else {
        setPickupTimeError("");
      }
    }
  }, [pickupDate, selectedTime]);

  useEffect(() => {
    if (!dropOffDate || !selectedDropTime) {
      setDropOffTimeError("");
      return;
    }

    const [hours, minutes] = selectedDropTime.split(":").map(Number);
    if (!((hours === 22 && minutes === 0) || (hours >= 9 && hours < 22))) {
      setDropOffTimeError("* Services available between 09:00 to 22:00");
    } else {
      setDropOffTimeError("");
    }
  }, [dropOffDate, selectedDropTime]);

  useEffect(() => {
    if (!pickupDate || !dropOffDate || !selectedTime || !selectedDropTime) {
      setIsSameDate(false);
      return;
    }

    try {
      const pDate = new Date(pickupDate);
      const dDate = new Date(dropOffDate);

      if (Number.isNaN(pDate.getTime()) || Number.isNaN(dDate.getTime())) {
        setIsSameDate(false);
        return;
      }

      const pDateStr = pDate.toISOString().split("T")[0];
      const dDateStr = dDate.toISOString().split("T")[0];

      if (pDateStr > dDateStr) {
        setIsSameDate(true);
      } else if (pDateStr === dDateStr) {
        const [pH, pM] = selectedTime.split(":").map(Number);
        const [dH, dM] = selectedDropTime.split(":").map(Number);
        const pTotal = pH * 60 + pM;
        const dTotal = dH * 60 + dM;

        // If drop-off time is later than pickup time on same day, it's valid (isSameDate = false)
        setIsSameDate(dTotal <= pTotal);
      } else {
        setIsSameDate(false);
      }
    } catch (e) {
      setIsSameDate(false);
    }
  }, [pickupDate, dropOffDate, selectedTime, selectedDropTime]);

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopState = (event: PopStateEvent) => {
      window.history.pushState(null, '', window.location.href);
      if (showCreateProduct) {
        setShowCreateProduct(false);
      } else if (showPickupMapModal) {
        setShowPickupMapModal(false);
      } else if (showReturnMapModal) {
        setShowReturnMapModal(false);
      } else if (showDetailsModal) {
        setShowDetailsModal(false);
      } else {
        setShowLogoutModal(true);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [showCreateProduct, showPickupMapModal, showReturnMapModal, showDetailsModal]);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    setShowLogoutModal(false);
    navigate('/');
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const validateTime = (time: string): boolean => {
    const [hours, minutes] = time.split(":").map(Number);
    return (hours === 22 && minutes === 0) || (hours >= 9 && hours < 22);
  };


  // const isMobile =
  //   /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
  //   window.innerWidth <= 768;

  // const openMobileTimePicker = async () => {
  //   const result = await DatePicker.present({
  //     mode: "time",
  //     theme: "dark",
  //     locale: "en-US",
  //     min: "09:00",
  //     max: "22:00",
  //   });
  //   if (result?.value) {
  //     const time = result.value.substring(11, 16); // get HH:mm
  //     handleTimeChange(time);
  //   }
  // };
  const handleTimeChange = (time: string | null) => {
    if (time) {
      setSelectedTime(time);
      setFieldErrors((prev) => ({ ...prev, pickupTime: undefined }));
    } else {
      setSelectedTime("");
      setPickupTimeError("");
    }
  };

  const handleDropOffTimeChange = (newTime: string | null) => {
    if (newTime) {
      setSelectedDropTime(newTime);
      setFieldErrors((prev) => ({ ...prev, dropOffTime: undefined }));
    } else {
      setSelectedDropTime("");
      setDropOffTimeError("");
    }
  };

  const handleCustomizeResult = (customResult: any) => {
    setCustomizeResult(customResult);
    // console.log("customResult updated", customResult);
    // Client-side filtering handled by useMemo(filteredCars)
  };

  const getActiveFiltersCount = () => {
    if (!customizeResult) return 0;
    let count = 0;
    count += (customizeResult.selectedCarTypes?.length || 0);
    count += (customizeResult.selectedBrands?.length || 0);
    count += (customizeResult.selectedFuelTypes?.length || 0);
    count += (customizeResult.selectedTransmissions?.length || 0);
    count += (Array.isArray(customizeResult.seat_capacity) ? customizeResult.seat_capacity.length : (customizeResult.seat_capacity ? 1 : 0));
    if (customizeResult.priceRange?.max > 0 && customizeResult.priceRange?.max < filterCatalog.maxPrice) count++;
    if (customizeResult.weeklyPriceRange?.max > 0 && customizeResult.weeklyPriceRange?.max < filterCatalog.maxWeeklyPrice) count++;
    if (customizeResult.monthlyPriceRange?.max > 0 && customizeResult.monthlyPriceRange?.max < filterCatalog.maxMonthlyPrice) count++;
    if (customizeResult.isUnlimitedMileage) count++;
    return count;
  };

  const handleCustomization = () => {
    setShowCreateProduct(true);
  };

  const [pickupSuggestions, setPickupSuggestions] = useState<
    { name: string; latitude: number; longitude: number }[]
  >([]);
  const [returnSuggestions, setReturnSuggestions] = useState<
    { name: string; latitude: number; longitude: number }[]
  >([]);

  const fetchCoordinates = async (searchQuery: string) => {
    try {
      const response = await axiosInstance.get(
        `https:///nominatim.kirkos.ae/search.php?q=${searchQuery}&format=geocodejson`,
      );
      if (response.data && response.data.features.length > 0) {
        const suggestions = response.data.features.map((feature: any) => ({
          name: feature.properties.geocoding.label,
          latitude: feature.geometry.coordinates[1], // Extract latitude from coordinates
          longitude: feature.geometry.coordinates[0], // Extract longitude from coordinates
        }));
        return suggestions;
      }
      return [];
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      return [];
    }
  };

  const handlePickupLocationChange = async (value: string) => {
    setSearchValues((prevValues: any) => {
      const newValues = { ...prevValues, pickup: value };
      if (returnToSameLocation) {
        newValues.return = value;
      }
      return newValues;
    });

    try {
      const suggestions = await fetchCoordinates(value);
      if (suggestions.length > 0) {
        const { latitude, longitude } = suggestions[0];
        setPickupSuggestions(suggestions);
        setPickupLocation({ latitude, longitude });

        // If synced, update return location as well (best effort based on first suggestion)
        // However, usually we wait for selection. But for typing sync:
        if (returnToSameLocation) {
          setReturnLocation({ latitude, longitude });
        }
      } else {
        setPickupSuggestions([]);
        setPickupLocation({ latitude: null, longitude: null });
        if (returnToSameLocation) {
          setReturnLocation({ latitude: null, longitude: null });
        }
      }
    } catch (error) {
      console.error("Error fetching pickup location suggestions:", error);
    }
  };

  const handleReturnLocationChange = async (value: string) => {
    setSearchValues((prevValues: any) => ({ ...prevValues, return: value }));
    try {
      const suggestions = await fetchCoordinates(value);
      if (suggestions.length > 0) {
        const { latitude, longitude } = suggestions[0];
        setReturnSuggestions(suggestions);
        setReturnLocation({ latitude, longitude });
      } else {
        setReturnSuggestions([]);
        setReturnLocation({ latitude: null, longitude: null });
      }
    } catch (error) {
      console.error("Error fetching return location suggestions:", error);
    }
  };

  // const handlePickupLocationSelection = (selectedLocation: {
  //   name?: string;
  //   latitude: any;
  //   longitude: any;
  // }) => {
  //   setPickupLocation({
  //     latitude: selectedLocation.latitude,
  //     longitude: selectedLocation.longitude,
  //   });

  //   // Clear suggestions after selection
  //   setPickupSuggestions([]);
  // };
  const handlePickupLocationSelection = (selectedLocation: {
    name?: string;
    latitude: any;
    longitude: any;
  }) => {
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      pickup: selectedLocation.name,
      ...(returnToSameLocation && { return: selectedLocation.name }),
    }));
    setPickupLocation({
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });

    if (returnToSameLocation) {
      setReturnLocation({
        latitude: selectedLocation.latitude,
        longitude: selectedLocation.longitude,
      });
      setFieldErrors((prev) => ({ ...prev, returnLocation: undefined }));
    }

    setFieldErrors((prev) => ({ ...prev, pickupLocation: undefined }));
    setPickupSuggestions([]);
  };

  const handleReturnLocationSelection = (selectedLocation: {
    name?: string;
    latitude: any;
    longitude: any;
  }) => {
    setSearchValues((prevValues: any) => ({
      ...prevValues,
      return: selectedLocation.name,
    }));
    setReturnLocation({
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });
    setFieldErrors((prev) => ({ ...prev, returnLocation: undefined }));
    setReturnSuggestions([]);
  };

  const handlePickupMapSelect = (selectedLocation: {
    name: string;
    latitude: number;
    longitude: number;
  }) => {
    handlePickupLocationSelection({
      name: selectedLocation.name,
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });
  };

  const handleReturnMapSelect = (selectedLocation: {
    name: string;
    latitude: number;
    longitude: number;
  }) => {
    handleReturnLocationSelection({
      name: selectedLocation.name,
      latitude: selectedLocation.latitude,
      longitude: selectedLocation.longitude,
    });
  };

  const handleToggleReturnToSameLocation = () => {
    if (!returnToSameLocation) {
      // Enable Sync
      setReturnToSameLocation(true);
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: searchValues.pickup,
      }));
      setReturnLocation(pickupLocation);
      setFieldErrors((prev) => ({ ...prev, returnLocation: undefined }));
      setReturnSuggestions([]);
    } else {
      // Disable Sync - Clear Return? Homepage behavior clears it.
      setReturnToSameLocation(false);
      // Keeping it cleared creates a distinct "unlock" feel, or we can keep the value.
      // Homepage clears it by hiding the input and showing it empty (re-init).
      // Actually Homepage clears it.
      setSearchValues((prevValues: any) => ({
        ...prevValues,
        return: "",
      }));
      setReturnLocation({ latitude: null, longitude: null });
    }
  };

  const handleSameAsContactAddress = async (): Promise<{ name: string; latitude: number; longitude: number } | null> => {
    try {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
      const customer_address = response?.data?.customer_details?.customer_address;
      if (
        customer_address &&
        customer_address.location_info &&
        customer_address.latitude &&
        customer_address.longitude
      ) {
        return {
          name: customer_address.location_info,
          latitude: parseFloat(customer_address.latitude),
          longitude: parseFloat(customer_address.longitude),
        };
      } else {
        toast.warn("No valid contact address found in your profile.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching contact address:", error);
      toast.error("Failed to load contact address.");
      return null;
    }
  };

  const handlePickupDateChange = (date: string | null) => {
    if (!date) {
      setPickupDate("");
      return;
    }
    const dateObj = new Date(date);
    setPickupDate(dateObj as any);
    setFieldErrors((prev) => ({ ...prev, pickupDate: undefined }));
  };

  const handleDropOffDateChange = (date: string | null) => {
    if (!date) {
      setDropOffDate("");
      return;
    }
    const dateObj = new Date(date);
    setDropOffDate(dateObj as any);
    setFieldErrors((prev) => ({ ...prev, dropOffDate: undefined }));
  };
  const handleClearSearch = () => {
    setIsRotating(true);
    setTimeout(() => setIsRotating(false), 800);
    setSearchValues({
      pickup: "",
      return: "",
    });
    setPickupLocation({ latitude: null, longitude: null });
    setReturnLocation({ latitude: null, longitude: null });
    setPickupDate("");
    setDropOffDate("");
    setSelectedTime("");
    setSelectedDropTime("");
    setCarName("");
    setFieldErrors({});
    setPickupTimeError("");
    setDropOffTimeError("");
    setIsSameDate(false);
    SetSearchCars([]); // Clear searched products
    setSearchResultHeading(false); // Hide results
    localStorage.removeItem("lastSavedSearchLocation");
  };

  const timer = setTimeout(() => {
    setIsLoading(false);
  }, 500);

  const validateSearchForm = () => {
    const errors: FieldErrors = {};

    if (!pickupDate) {
      errors.pickupDate = "Pickup date is required";
    }
    if (!dropOffDate) {
      errors.dropOffDate = "Drop-off date is required";
    }
    if (!selectedTime) {
      errors.pickupTime = "Pickup time is required";
    }
    if (!selectedDropTime) {
      errors.dropOffTime = "Drop-off time is required";
    }
    if (!pickupLocation.latitude || !pickupLocation.longitude) {
      errors.pickupLocation = "Pickup location is required";
    }
    if (!returnLocation.latitude || !returnLocation.longitude) {
      errors.returnLocation = "Return location is required";
    }

    if (pickupTimeError || dropOffTimeError) {
      return false;
    }

    setFieldErrors(errors);
    // Return false if there are validation errors OR if dates are the same (already shown inline)
    return Object.keys(errors).length === 0 && !isSameDate;
  };

  const handleSubmit = async (customValues?: any) => {
    if (!validateSearchForm()) {
      return;
    }
    // console.log("handleSubmit is called");
    if (merchantId1 && customerId) {
      handleClear.mutate();
    }
    dispatch(clearBookingValues());

    // Save location data to localStorage for future use
    const searchToPersistent = {
      pickupPlace: searchValues.pickup,
      returnPlace: searchValues.return,
      pickupLocLatitude: pickupLocation.latitude,
      pickupLocLongitude: pickupLocation.longitude,
      returnLocLatitude: returnLocation.latitude,
      returnLocLongitude: returnLocation.longitude,
      returnToSameLocation: returnToSameLocation,
    };
    try {
      localStorage.setItem(
        "lastSavedSearchLocation",
        JSON.stringify(searchToPersistent),
      );
    } catch (err) {
      console.error("Failed to save location data to localStorage", err);
    }

    let seatCapacity = null;
    let carType = null;
    let amountRange = 0;
    let modelYear = null;
    let Mileage = 0;

    const activeCustomize = customValues || customizeResult;
    if (activeCustomize) {
      const { seat_capacity, car_type, amount_range, mileage, product_name } =
        activeCustomize;
      seatCapacity = seat_capacity;
      carType = car_type;
      amountRange = amount_range;
      modelYear = product_name;
      Mileage = Number(mileage);
    }

    // Car Name from Dashboard input should be used if available
    if (carName && !modelYear) {
      modelYear = carName;
    }
    // console.log("activeCustomize", activeCustomize);

    const convertToString = (value: number | null) =>
      value !== null ? value.toString() : "";

    const userData: ProductSearch = {
      index: 1,
      count: 10,
      sort_order: "ASC",
      pickup_location: {
        latitude: convertToString(pickupLocation.latitude),
        longitude: convertToString(pickupLocation.longitude),
      },
      return_location: {
        latitude: convertToString(returnLocation.latitude),
        longitude: convertToString(returnLocation.longitude),
      },
      // pickup_date: pickupDate,
      // dropOff_date: dropOffDate,
      pickup_date: moment(pickupDate).format("YYYY-MM-DD"),
      dropOff_date: moment(dropOffDate).format("YYYY-MM-DD"),
      pickup_time: selectedTime,
      dropOff_time: selectedDropTime,
      ...(seatCapacity && { seat_capacity: seatCapacity }),
      ...(carType && { car_type: carType }),
      ...(amountRange !== 0 && { amount_range: amountRange.toFixed(1) }),
      ...(Mileage !== 0 && { mileage: Mileage.toFixed(1) }),
      product_name: modelYear || carName || "",
    };
    // console.log("SearchReq", userData);
    if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
      ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
    }
    ReactPixel.track("Search", {
      content_type: "search",
      content_name: "Car Search After Login",
      content_category: "Car Search",
      pickup_time: selectedTime,
      dropOff_time: selectedDropTime,
      pickup_date: pickupDate,
      dropOff_date: dropOffDate,
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "search_submit",
        page_type: "standard",
        page_path: window.location.pathname,
        page_url: window.location.href,
        search_source: "dashboard",
        pickup_datetime: `${pickupDate} ${selectedTime}`,
        dropoff_datetime: `${dropOffDate} ${selectedDropTime}`
      }
    });

    await trackEvent({
      event_name: {
        web: "Kirkos_DashboardSearchButton",
        app: "Kirkos_DashboardSearchButton_App",
      },
      event_category: "Dashboard_Info",
      module: "Dashboard",
      payload: {
        pickup_date: pickupDate,
        dropOff_date: dropOffDate,
        pickup_time: selectedTime,
        dropOff_time: selectedDropTime,
        pickup_location: {
          latitude: convertToString(pickupLocation.latitude),
          longitude: convertToString(pickupLocation.longitude),
        },
        return_location: {
          latitude: convertToString(returnLocation.latitude),
          longitude: convertToString(returnLocation.longitude),
        },
      },
    });

    handleSearch.mutate(userData);
    setSearchResultHeading(true);
    setIsLoading(true);
    clearTimeout(timer);
  };

  const handleSearch = useMutation({
    mutationFn: (userData: ProductSearch) =>
      axiosInstance.post(API_URL.PRODUCT_SEARCH, userData),
    onSuccess: async (successResponse) => {
      if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
        ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
      }
      ReactPixel.track("Search", {
        content_type: "search_results",
        content_name: "Car Search Results",
        content_category: "Car Search",
        results_count: successResponse.data?.length || 0,
      });
      await trackEvent({
        event_name: {
          web: "Kirkos_DashboardSearchButton_Success",
          app: "Kirkos_DashboardSearchButton_Success_App",
        },
        event_category: "Dashboard_Info",
        module: "Dashboard",
        payload: {
          status: "success",
          results_count: successResponse.data?.length || 0,
        },
      });

      searchResultData = successResponse.data;
      SetSearchCars(searchResultData);
      setFieldErrors({});
      const searchResultSection = document.getElementById(
        "searchResultSection",
      );
      if (searchResultSection) {
        searchResultSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      searchResultData?.map((item: any, index: number) => {
        // console.log(`Product ID ${index + 1}:`, item.product_name);
      });
    },

    onError: (error) => {
      console.error("Search error:", error);
    },
  });

  const decodeToken = (token: any) => {
    if (token) {
      return JSON.parse(atob(token.split(".")[1]));
    } else {
      return null;
    }
  };

  const decodedToken = decodeToken(accessToken);
  const customerId =
    decodedToken && decodedToken["customer-id"]
      ? decodedToken["customer-id"]
      : null;

  const handleBooking = useMutation({
    mutationFn: (userData: bookingData) =>
      axiosInstance.post(
        `${API_URL.BOOKING_NOW}/${customerId}/carts`,
        userData,
      ),
    onSuccess: (successResponse) => {
      console.log("handle booking success");
    },

    onError: (error) => {
      console.log("there was an error", error);
    },
  });

  useEffect(() => {
    const getCartData = async () => {
      try {
        const response = await axiosInstance.get(
          `${API_URL.GET_CART}/${customerId}/carts`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );

        const merchantKey = Object.keys(response.data)[0];
        setMerchantId1(merchantKey);

        // console.log("Cart data:", response.data);
      } catch (error) {
        console.error("Error fetching cart data:", error);
      }
    };

    if (customerId) {
      getCartData();
    }
  }, [customerId]);

  const handleClear = useMutation({
    mutationFn: () =>
      axiosInstance.get(
        `${API_URL.CLEAR_CART}/${customerId}/carts/${merchantId1}/clear`,
      ),

    onSuccess: (successResponse) => {
      console.log("successResponse");
    },
    onError: (error: any) => {
      if (error?.data?.message) {
        console.log(error);
      }
    },
  });
  const handleUpgrade = useMutation({
    mutationFn: (upgradeData: any) =>
      axiosInstance.post(`${API_URL.PRODUCT_UPGRADE}`, upgradeData),
    onSuccess: (successResponse) => {
      console.log("upgrade success");
    },
    onError: (error) => {
      console.log("upgrade error", error);
    },
  });

  const handleBookingClick = async (productId: string) => {
    const selectedItem = searchCars.find(
      (item: any) => item.product_id === productId,
    );
    if (!selectedItem) {
      console.error("Selected item not found in searchCars array.");
      return;
    }

    proceedWithBooking(selectedItem);

    // const upgradePayload = {
    //   pickup_date: moment(pickupDate).format("YYYY-MM-DD"),
    //   dropOff_date: moment(dropOffDate).format("YYYY-MM-DD"),
    //   pickup_time: selectedTime,
    //   dropOff_time: selectedDropTime,
    //   product_id: selectedItem?.product_id,
    //   merchant_id: selectedItem?.merchant_id,
    // };

    // try {
    //   const upgradeResponse = await handleUpgrade.mutateAsync(upgradePayload);
    //   const upgradeProduct = upgradeResponse?.data;
    //   if (
    //     upgradeProduct &&
    //     Array.isArray(upgradeProduct) &&
    //     upgradeProduct.length > 0
    //   ) {
    //     setUpgradeData(upgradeProduct[0]);
    //     setShowUpgradeModal(true);
    //   } else {
    //     proceedWithBooking(selectedItem);
    //   }
    // } catch (error) {
    //   proceedWithBooking(selectedItem);
    // }
  };
  // eslint-disable-next-line no-empty-pattern
  const { } = useQuery<CustomerDetails, Error>({
    queryKey: ["details"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URL.CUSTOMER_DETAILS);
      // console.log(response, "response");
      const fbMetaId = sessionStorage.getItem("fbclid");
      const utmParams = JSON.parse(
        sessionStorage.getItem("utm_params") || "{}",
      );
      const campaignType = utmParams.utm_campaign || null;

      try {
        const ipResponse = await fetch("https://api.ipify.org?format=json");
        const ipData = await ipResponse.json();
        const crmResponse = await axiosInstance.post(API_URL.CRM_LEADS, {
          full_name: response?.data?.customer_details?.firstName || "",
          phone_number: response?.data?.customer_details?.phone_no || "",
          email: response?.data?.customer_details?.email || "",
          source: "website",
          campaign_name: campaignType || "",
          ip_address: ipData?.ip,
          meta_click_id: fbMetaId || "",
        });
        // console.log("CRM lead created:", crmResponse.data);
        sessionStorage.setItem("pixel_initialized", "true");
      } catch (error) {
        console.error("Error creating CRM lead:", error);
      }

      return response.data;
    },
  });

  const proceedWithBooking = async (selectedItem: any) => {
    const payload: bookingData = {
      product_id: selectedItem?.product_id,
      base_product_id: selectedItem?.product_id,
      product_name: selectedItem?.product_name,
      product_description: selectedItem?.product_description,
      merchant_id: selectedItem?.merchant_id,
      quantity: 1,
      item_id: "",
      promotion_id: "",
      price: selectedItem?.product_details_car?.price_per_day,
      price_per_week: selectedItem?.product_details_car?.price_per_week,
      price_per_month: selectedItem?.product_details_car?.price_per_month,
      toppings: [],
      buy_more_pay_less: {},
      discount_event: {},
      variant: {},
      shop_id: selectedItem?.vendor_product_inventories[0]?.vendor_id,
      product_details: selectedItem?.product_details?.description,
    };
    if (!(window as any).fbq && process.env.REACT_APP_META_PIXEL_ID) {
      ReactPixel.init(process.env.REACT_APP_META_PIXEL_ID);
    }
    ReactPixel.track("AddToCart", {
      content_type: "Product",
      content_name: payload?.product_name,
      content_category: "Add to Cart",
      content_ids: [payload?.product_id],
    });
    TagManager.dataLayer({
      dataLayer: {
        event: "add_to_cart",
        page_type: "standard",
        page_path: window.location.pathname,
        page_url: window.location.href,
        product_id: payload?.product_id,
        product_name: payload?.product_name
      }
    });
    await trackEvent({
      event_name: {
        web: "Kirkos_Dashboard_Add_To_Cart",
        app: "Kirkos_Dashboard_Add_To_Cart",
      },
      event_category: "Dashboard_Info",
      module: "Dashboard",
      payload: payload,
    });
    handleBooking.mutate(payload);

    const searchData = {
      pickupPlace: searchValues.pickup,
      returnPlace: searchValues.return,
      returnToSameLocation,
      pickupDate,
      dropOffDate,
      selectedTime,
      selectedDropTime,
      pickupLocLatitude: pickupLocation?.latitude?.toString(),
      pickupLocLongitude: pickupLocation?.longitude?.toString(),
      returnLocLatitude: returnLocation?.latitude?.toString(),
      returnLocLongitude: returnLocation?.longitude?.toString(),
      customizeResult, // Include customized search values
    };
    navigate("/customer/unified-booking", {
      state: {
        selectedItem,
        merchantId: selectedItem.merchant_id,
        searchData,
        pickupCharge:
          selectedItem?.product_car_insurance?.pick_up_charge_outside_40km,
        deliveryCharge:
          selectedItem?.product_car_insurance?.delivery_charges_outside_40km,
      },
    });
  };

  const UpgradeModal = () => {
    if (!upgradeData) return null;

    const selectedItem = searchCars.find(
      (item: any) => item.product_id === selectProductId,
    );

    const priceDifference =
      upgradeData?.product_details_car?.price_per_day -
      selectedItem?.product_details_car?.price_per_day;

    return (
      <Modal
        show={showUpgradeModal}
        onHide={() => setShowUpgradeModal(false)}
        size="sm"
        centered
      >
        <Modal.Header closeButton className="border-0 pb-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="container-fluid text-center">
            {/* Upgrade Message */}
            <div
              className="alert alert-warning mb-2 py-2"
              style={{
                backgroundColor: "#fff3cd",
                borderColor: "#ffc107",
                color: "#856404",
                fontSize: "0.85rem",
              }}
            >
              Pay another{" "}
              <span style={{ color: "#fe9f06", fontWeight: "bold" }}>
                {priceDifference} AED
              </span>/day{" "} and drive {" "}
              <strong>{upgradeData?.product_name?.toUpperCase()}</strong>
            </div>

            {/* Image Section */}
            <div className="mb-2">
              {upgradeData?.product_details?.images?.length > 0 ? (
                <img
                  className="img-fluid rounded shadow-sm"
                  src={upgradeData.product_details.images[0]}
                  alt={upgradeData?.product_name}
                  style={{
                    width: "100%",
                    maxHeight: "120px",
                    objectFit: "contain",
                  }}
                />
              ) : (
                <img
                  src={noun_no_image}
                  alt="No image"
                  className="img-fluid rounded"
                  style={{
                    width: "100%",
                    maxHeight: "120px",
                    objectFit: "contain",
                  }}
                />
              )}
            </div>

            {/* Product Name */}
            <h5
              className="mb-0"
              style={{
                fontSize: "0.95rem",
                fontWeight: "700",
                color: "#F0B64F",
              }}
            >
              {upgradeData?.product_name?.toUpperCase() || "UPGRADED VEHICLE"}
            </h5>
            <p className="extra-small mb-2" style={{ fontSize: "0.7rem", color: "#ADACAC" }}>
              {upgradeData?.shop_name || ""}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0 pb-3 justify-content-center">
          <div className="d-flex gap-2">
            <button
              className="btn btn-outline-secondary"
              style={{
                fontSize: "0.85rem",
                height: "34px",
                width: "80px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              onClick={() => {
                const selectedItem = searchCars.find(
                  (item: any) => item.product_id === selectProductId,
                );
                setShowUpgradeModal(false);
                proceedWithBooking(selectedItem);
              }}
            >
              NO
            </button>
            <button
              className="book-now-button-style"
              style={{
                fontSize: "0.85rem",
                height: "34px",
                width: "80px",
                margin: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              }}
              onClick={() => {
                setShowUpgradeModal(false);
                proceedWithBooking(upgradeData);
              }}
            >
              YES
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-8px);
            }
            60% {
              transform: translateY(-4px);
            }
          }
          
          /* Hide floating search button on mobile and tablet */
          @media (max-width: 1024px) {
            .floating-search-button-desktop {
              display: none !important;
            }
          }
          
          .merchant-name-container {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            display: block;
            transition: all 0.3s ease;
          }
          .card-custom-my-account:hover .merchant-name-container {
            white-space: normal;
            word-break: break-word;
          }

          .landing-shell__error,
          .landing-shell__inline-error {
            border-radius: 12px;
            border: 1px solid rgba(220, 53, 69, 0.28);
            background: rgba(220, 53, 69, 0.08);
            color: #ffc7cf;
            padding: 0.8rem 0.95rem;
            font-size: 0.84rem;
            line-height: 1.45;
          }
          .applied-filter-chip {
            background: rgba(240, 182, 79, 0.15);
            color: #F0B64F;
            border: 1px solid rgba(240, 182, 79, 0.3);
            border-radius: 50px;
            padding: 4px 14px;
            font-size: 12px;
            font-weight: 600;
            display: flex;
            align-items: center;
            transition: all 0.2s ease;
          }
          .applied-filter-chip:hover {
            background: rgba(240, 182, 79, 0.25);
            border-color: #F0B64F;
          }
          .cursor-pointer {
            cursor: pointer;
          }
        `}
      </style>
      <div className="row justify-content-md-center my-account-component-div" style={{ fontFamily: "'HarmonyOS Sans', sans-serif" }}>
        <div className="col-md-12">
          {/* <div className="row ">
            <div
              className="col-md-12 background-div-carousal"
              style={{ position: "relative" }}
            >
              <Carousel
                className="customer-carousel"
                pause={false}
                controls={false}
              >
                <Carousel.Item>
                  <img
                    src={carousel_image_one}
                    alt=""
                    className="img-fluid carousal-image-my-account"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    src={carousel_image_one}
                    alt=""
                    className="img-fluid carousal-image-my-account"
                  />
                </Carousel.Item>
              </Carousel>

              <div
                className="floating-search-button-desktop"
                style={{
                  position: "absolute",
                  bottom: "30px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  zIndex: 10,
                }}
              >
                <button
                  onClick={() => {
                    const searchSection = document.querySelector(
                      ".custom-myAccount-card",
                    );
                    if (searchSection) {
                      searchSection.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                  style={{
                    background:
                      "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
                    border: "none",
                    borderRadius: "50px",
                    padding: "16px 40px",
                    color: "#000",
                    fontSize: "16px",
                    fontWeight: "700",
                    cursor: "pointer",
                    boxShadow: "0 6px 25px rgba(255, 215, 0, 0.6)",
                    transition: "all 0.3s ease",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "12px",
                    letterSpacing: "0.5px",
                    textTransform: "uppercase",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform =
                      "translateY(-3px) scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 30px rgba(255, 215, 0, 0.8)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 25px rgba(255, 215, 0, 0.6)";
                  }}
                >
                  🔍 SEARCH CARS
                  <span
                    style={{
                      animation: "bounce 2s infinite",
                      display: "inline-block",
                      fontSize: "18px",
                    }}
                  ></span>
                </button>
              </div>
            </div>
          </div> */}
          <div className="row text-center pt-3 pb-3">
            <div className="col-md-12  d-flex justify-content-center me-2">
              <span className="myAccount-head-card ">
                Find the best car rental with KIRKOS
              </span>
              <img
                src={arrow_rounded}
                alt=""
                width={100}
                className="image-arrow-customer"
              />
            </div>
          </div>

          {/* Removed standalone button - now overlaid on carousel */}
          <style>{mobileFilterStyles}</style>
          {/* -------------------------------------- search card start ------------------------------- */}
          <div id="searchFormSection" className={`card custom-myAccount-card position-relative ${isMobileView ? 'mobile-search-card' : ''}`}>
            <div className={`card-body position-relative ${isMobileView ? 'p-3' : 'px-4 px-md-5 py-4'}`}>


              {/* Toggle Switch and Clear All button - positioned absolutely on desktop, relative on mobile */}
              <div
                className="return-toggle-wrapper d-flex align-items-center gap-3"
                style={isMobileView ? {
                  position: 'relative',
                  justifyContent: 'flex-end',
                  width: '100%',
                  marginBottom: '15px',
                  zIndex: 10,
                  paddingRight: '4px'
                } : {
                  top: '16px',
                  right: '16px',
                  position: 'absolute',
                  zIndex: 10
                }}
              >


                <div className="d-flex align-items-center gap-2">
                  <label style={{
                    fontSize: '12px',
                    color: '#FFD700',
                    fontWeight: '600',
                    margin: 0,
                    cursor: 'pointer',
                    userSelect: 'none',
                  }}
                    onClick={handleToggleReturnToSameLocation}
                  >
                    Return to same location
                  </label>
                  <div
                    onClick={handleToggleReturnToSameLocation}
                    style={{
                      width: '44px',
                      height: '24px',
                      borderRadius: '12px',
                      backgroundColor: returnToSameLocation ? '#10B981' : '#555',
                      position: 'relative',
                      cursor: 'pointer',
                      transition: 'background-color 0.3s ease',
                      border: returnToSameLocation ? '2px solid #10B981' : '2px solid #555',
                    }}
                  >
                    <div style={{
                      width: '18px',
                      height: '18px',
                      borderRadius: '50%',
                      backgroundColor: '#fff',
                      position: 'absolute',
                      top: '1px',
                      left: returnToSameLocation ? '22px' : '2px',
                      transition: 'left 0.3s ease',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                    }} />
                  </div>
                </div>
              </div>

              {/* Location Inputs Section */}
              <div className="row">
                {/* Pickup Location */}
                <div
                  className={`mb-4 ${returnToSameLocation ? "col-12" : "col-12 col-md-6"}`}
                >
                  <div className="position-relative">
                    <div
                      onClick={() => setShowPickupMapModal(true)}
                      style={{ cursor: "pointer" }}
                    >
                      <FloatingInputLocation
                        inputType={"text"}
                        className={""}
                        placeholder={"Pick Up Location"}
                        label={"PICK UP LOCATION"}
                        inputName="pickUpLocation"
                        selectedLocationName={searchValues.pickup}
                        onInputChange={(value: string) =>
                          handlePickupLocationChange(value)
                        }
                        control={control}
                        editable={false}
                      />
                    </div>

                    {fieldErrors.pickupLocation && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "12px", fontWeight: "500" }}
                      >
                        {fieldErrors.pickupLocation}
                      </div>
                    )}
                  </div>
                </div>


                {/* Return Location - only shown when toggle is OFF */}
                {!returnToSameLocation && (
                  <div className="col-12 col-md-6 mb-4">
                    <div className="position-relative">
                      <div
                        onClick={() => setShowReturnMapModal(true)}
                        style={{ cursor: "pointer" }}
                      >
                        <FloatingInputLocation
                          inputType={"text"}
                          className={""}
                          placeholder={"Return Location"}
                          label={"RETURN LOCATION"}
                          inputName="returnLocation"
                          onInputChange={(value: string) =>
                            handleReturnLocationChange(value)
                          }
                          selectedLocationName={searchValues.return}
                          control={control}
                          editable={false}
                        />
                      </div>

                      {fieldErrors.returnLocation && (
                        <div
                          className="text-danger mt-1"
                          style={{ fontSize: "12px", fontWeight: "500" }}
                        >
                          {fieldErrors.returnLocation}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Date & Time Inputs Section */}
              <div className="row g-4 mb-4">
                {/* Pickup DateTime */}
                <div className="col-12 col-md-6">
                  <DateTimePickerComponent
                    label="Pick up Date & Time"
                    placeholder="Select date & time"
                    className="w-100"
                    dateValue={
                      pickupDate instanceof Date
                        ? !Number.isNaN(pickupDate.getTime())
                          ? pickupDate.toISOString().split("T")[0]
                          : ""
                        : pickupDate && !Number.isNaN(new Date(pickupDate).getTime())
                          ? new Date(pickupDate).toISOString().split("T")[0]
                          : pickupDate
                    }
                    timeValue={selectedTime}
                    onDateChange={handlePickupDateChange}
                    onTimeChange={handleTimeChange}
                    maxDate={dropOffDate ? new Date(dropOffDate) : null}
                    maxTime={
                      pickupDate &&
                        dropOffDate &&
                        !Number.isNaN(new Date(pickupDate).getTime()) &&
                        !Number.isNaN(new Date(dropOffDate).getTime()) &&
                        new Date(pickupDate).toISOString().split("T")[0] ===
                        new Date(dropOffDate).toISOString().split("T")[0]
                        ? selectedDropTime
                        : null
                    }
                    minDate={(() => {
                      const today = new Date();
                      const currentHour = today.getHours();
                      const currentMinutes = today.getMinutes();
                      const isNoServiceToday = (currentHour * 60 + currentMinutes + 120 >= 22 * 60);
                      if (isNoServiceToday) {
                        const tom = new Date();
                        tom.setDate(tom.getDate() + 1);
                        return tom;
                      }
                      return today;
                    })()}
                    minTime={(() => {
                      // Only restrict the minimum time when the selected pickup date is TODAY.
                      // For tomorrow or any future date, all times are valid → return null.
                      if (!pickupDate) return null;
                      const today = new Date();
                      const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
                      const pickupStr =
                        pickupDate instanceof Date
                          ? `${pickupDate.getFullYear()}-${String(pickupDate.getMonth() + 1).padStart(2, "0")}-${String(pickupDate.getDate()).padStart(2, "0")}`
                          : pickupDate;
                      if (pickupStr !== todayStr) return null;
                      const minTimeDate = new Date(today.getTime() + 2 * 60 * 60 * 1000);
                      const h = String(minTimeDate.getHours()).padStart(2, "0");
                      const m = String(minTimeDate.getMinutes()).padStart(2, "0");
                      return `${h}:${m}`;
                    })()}
                    showTodayPickupMessage={(() => {
                      if (!pickupDate) return false;
                      const todayStr = new Date().toISOString().split("T")[0];
                      const pickupStr =
                        pickupDate instanceof Date
                          ? pickupDate.toISOString().split("T")[0]
                          : new Date(pickupDate).toISOString().split("T")[0];
                      return pickupStr === todayStr;
                    })()}
                    autoScrollToFirstAvailableTime={true}
                  />
                </div>

                {/* Dropoff DateTime */}
                <div className="col-12 col-md-6">
                  <DateTimePickerComponent
                    label="Dropoff Date & Time"
                    placeholder="Select date & time"
                    className="w-100"
                    dateValue={
                      dropOffDate instanceof Date
                        ? !Number.isNaN(dropOffDate.getTime())
                          ? dropOffDate.toISOString().split("T")[0]
                          : ""
                        : dropOffDate && !Number.isNaN(new Date(dropOffDate).getTime())
                          ? new Date(dropOffDate).toISOString().split("T")[0]
                          : dropOffDate
                    }
                    timeValue={selectedDropTime}
                    onDateChange={handleDropOffDateChange}
                    onTimeChange={handleDropOffTimeChange}
                    minDate={pickupDate ? new Date(pickupDate) : null}
                    minTime={
                      pickupDate &&
                        dropOffDate &&
                        !Number.isNaN(new Date(pickupDate).getTime()) &&
                        !Number.isNaN(new Date(dropOffDate).getTime()) &&
                        new Date(pickupDate).toISOString().split("T")[0] ===
                        new Date(dropOffDate).toISOString().split("T")[0]
                        ? selectedTime
                        : null
                    }
                    maxDate={
                      pickupDate
                        ? (() => {
                          const d = new Date(pickupDate);
                          d.setDate(d.getDate() + 30);
                          return d;
                        })()
                        : null
                    }
                  />
                </div>
              </div>

              {/* Consolidated Date/Time Error Messages */}
              {(pickupTimeError ||
                dropOffTimeError ||
                fieldErrors.pickupDate ||
                fieldErrors.pickupTime ||
                fieldErrors.dropOffDate ||
                fieldErrors.dropOffTime) && (
                  <div className="landing-shell__error mb-4">
                    <div className="d-flex align-items-center gap-2">
                      <Tools size={16} className="text-danger" />
                      <span>
                        {pickupTimeError ||
                          dropOffTimeError ||
                          fieldErrors.pickupDate ||
                          fieldErrors.pickupTime ||
                          fieldErrors.dropOffDate ||
                          fieldErrors.dropOffTime}
                      </span>
                    </div>
                  </div>
                )}

              {isSameDate && (
                <div className="landing-shell__inline-error mb-4">
                  <div className="d-flex align-items-center gap-2">
                    <Tools size={16} className="text-danger" />
                    <span>Drop-off date must be later than Pick-up date. Please select a valid date.</span>
                  </div>
                </div>
              )}

              {/* Car Name Search */}
              <div className="row mb-4">
                <div className="col-12">
                  <div className="text-start">
                    <label
                      htmlFor="dashboardCarSearch"
                      className="form-label"
                      style={{ fontWeight: 400, fontSize: "14px", color: "#9A999D" }}
                    >
                      BRAND NAME (OPTIONAL)
                    </label>
                    <input
                      type="text"
                      className="merchant-input-style-create-product w-100"
                      id="dashboardCarSearch"
                      placeholder="Search brand name (e.g. Nissan Patrol)"
                      value={carName}
                      style={{ borderWidth: "2px", borderColor: "#ADACAC" }}
                      onChange={(e) => setCarName(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Search Button */}
              <div className="d-flex flex-column flex-md-row justify-content-end mt-3 gap-3">
                <button
                  type="button"
                  className="d-flex align-items-center gap-1 border-0"
                  onClick={handleClearSearch}
                  style={{
                    background: "rgba(0, 0, 0, 0.05)",
                    color: "#cbc8c8ff",
                    fontSize: "12px",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    transition: "all 0.2s",
                    fontWeight: "600",
                    width: "fit-content"
                  }}
                >
                  <ArrowCounterclockwise size={14} className={isRotating ? "reset-spin" : ""} />
                  Clear All
                </button>
                <button
                  className="btn search-submit-btn"
                  onClick={() => handleSubmit()}
                  style={{
                    padding: isMobileView ? "16px" : "12px 40px",
                    fontSize: isMobileView ? "16px" : "16px",
                    fontWeight: "800",
                    minWidth: isMobileView ? "100%" : "180px",
                    borderRadius: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    background: isMobileView ? 'linear-gradient(135deg, #F0B64F 0%, #D8A845 100%)' : undefined,
                    color: isMobileView ? '#000' : undefined,
                    border: isMobileView ? 'none' : undefined,
                    boxShadow: isMobileView ? '0 10px 20px rgba(240, 182, 79, 0.2)' : undefined
                  }}
                >
                  SEARCH VEHICLES
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Filter Drawer */}
          <Offcanvas
            show={showFilterDrawer}
            onHide={() => setShowFilterDrawer(false)}
            placement="bottom"
            className="home-filter-drawer"
            style={{ height: '85vh' }}
          >
            <div className="d-flex flex-column h-100">
              <Offcanvas.Header closeButton closeVariant="white">
                <Offcanvas.Title className="text-white fw-bold">FILTERS</Offcanvas.Title>
              </Offcanvas.Header>

              <Offcanvas.Body className="p-0 flex-grow-1 overflow-auto custom-scrollbar">
                <CustomerCustomizeYourSearch
                  isOpen={true}
                  onClose={() => setShowFilterDrawer(false)}
                  onCustomizeResult={(res: any) => {
                    setCarName(res.product_name || "");
                    handleCustomizeResult(res);
                  }}
                  initialValues={{
                    ...customizeResult,
                    product_name: carName || customizeResult?.product_name || "",
                  }}
                  filterCatalog={filterCatalog}
                  isInline={true}
                  totalCars={searchCars}
                />
              </Offcanvas.Body>

              {/* Drawer Apply Button - Fixed at bottom */}
              <div className="p-3 mt-auto" style={{
                background: '#12151c',
                borderTop: '1px solid rgba(255,255,255,0.05)',
                zIndex: 10
              }}>
                <button
                  className="btn w-100"
                  onClick={() => setShowFilterDrawer(false)}
                  style={{
                    background: 'linear-gradient(135deg, #F0B64F 0%, #D8A845 100%)',
                    color: '#000',
                    fontWeight: '800',
                    borderRadius: '12px',
                    padding: '14px',
                    textTransform: 'uppercase',
                    fontSize: '14px',
                    boxShadow: '0 8px 20px rgba(240, 182, 79, 0.3)'
                  }}
                >
                  Apply Filters
                </button>
              </div>
            </div>
          </Offcanvas>
          {/* -------------------------------------- search card end ------------------------------- */}

          {/* -------------------------------------- search result start ------------------------------- */}
          <div id="searchResultSection">
            <div
              className={`col-12 mt-4 ${searchResultHeading ? "" : "d-none"
                }`}
            >
              <div className="row text-start pt-4 pb-2">
                <div
                  className={`col-md-12 ${searchResultHeading ? "" : "d-none"
                    }`}
                >
                  <div className="d-flex align-items-center gap-3">
                    <h2 className="myAccount-head mb-0" style={{ fontSize: "28px", fontWeight: "700", color: "#fff", letterSpacing: "-0.5px" }}>
                      Available <span style={{ color: "#F0B64F" }}>Options</span>
                    </h2>
                    <div className="flex-grow-1" style={{ height: "1px", background: "linear-gradient(90deg, #F0B64F 0%, rgba(240, 182, 79, 0) 100%)", opacity: 0.5 }}></div>
                  </div>
                  <p className="mt-2 mb-0" style={{ fontSize: "14px", color: "rgba(255,255,255,0.6)", fontWeight: "500" }}>
                    We found the best matches for your trip
                  </p>
                </div>
              </div>

              <div className="row">
                {/* Left Sidebar Filter */}
                {!isMobileView && (
                  <div className="col-md-3 mb-4">
                    <CustomerCustomizeYourSearch
                      isOpen={true}
                      onClose={() => { }}
                      onCustomizeResult={(res: any) => {
                        setCarName(res.product_name || "");
                        handleCustomizeResult(res);
                      }}
                      initialValues={{
                        ...customizeResult,
                        product_name: carName || customizeResult?.product_name || "",
                      }}
                      filterCatalog={filterCatalog}
                      isInline={true}
                      totalCars={searchCars}
                    />
                  </div>
                )}

                {/* Mobile Filter Button - Premium Layout Matching Homepage */}
                {isMobileView && searchResultHeading && (
                  <div className="home-mobile-filter-section w-100">
                    <div className="d-flex gap-2 align-items-center justify-content-between mb-3">
                      <button
                        className="home-mobile-filter-btn"
                        type="button"
                        onClick={() => setShowFilterDrawer(true)}
                      >
                        <Funnel size={16} className="me-2" />
                        Filters
                        {getActiveFiltersCount() > 0 && (
                          <span className="home-results-count-pill">
                            {getActiveFiltersCount()}
                          </span>
                        )}
                      </button>
                      <button
                        className="btn btn-link btn-sm text-decoration-none p-0 ms-1"
                        style={{ color: '#F0B64F', fontSize: '11px', fontWeight: '700' }}
                        onClick={() => handleCustomizeResult(null)}
                      >
                        CLEAR ALL
                      </button>
                    </div>

                    {/* Applied Filters Summary for Mobile */}
                    {getActiveFiltersCount() > 0 && (
                      <div className="home-results-applied--mobile mb-3">
                        <div className="home-results-applied__list">
                          {customizeResult?.selectedCarTypes?.map((type: string) => (
                            <div key={type} className="home-results-chip" onClick={() => {
                              const newTypes = customizeResult.selectedCarTypes.filter((t: string) => t !== type);
                              handleCustomizeResult({ ...customizeResult, selectedCarTypes: newTypes });
                            }}>
                              {type} ×
                            </div>
                          ))}
                          {customizeResult?.selectedBrands?.map((brand: string) => (
                            <div key={brand} className="home-results-chip" onClick={() => {
                              const newBrands = customizeResult.selectedBrands.filter((b: string) => b !== brand);
                              handleCustomizeResult({ ...customizeResult, selectedBrands: newBrands });
                            }}>
                              {brand} ×
                            </div>
                          ))}
                          {customizeResult.selectedFuelTypes?.map((fuel: string) => (
                            <div key={fuel} className="home-results-chip" onClick={() => {
                              const newFuels = customizeResult.selectedFuelTypes.filter((f: string) => f !== fuel);
                              handleCustomizeResult({ ...customizeResult, selectedFuelTypes: newFuels });
                            }}>
                              {fuel} ×
                            </div>
                          ))}
                          {customizeResult.selectedTransmissions?.map((trans: string) => (
                            <div key={trans} className="home-results-chip" onClick={() => {
                              const newTrans = customizeResult.selectedTransmissions.filter((t: string) => t !== trans);
                              handleCustomizeResult({ ...customizeResult, selectedTransmissions: newTrans });
                            }}>
                              {trans} ×
                            </div>
                          ))}
                          {customizeResult.seat_capacity && (Array.isArray(customizeResult.seat_capacity) ? customizeResult.seat_capacity : [customizeResult.seat_capacity]).map((seat: number) => (
                            <div key={seat} className="home-results-chip" onClick={() => {
                              const seats = Array.isArray(customizeResult.seat_capacity) ? customizeResult.seat_capacity : [customizeResult.seat_capacity];
                              const newSeats = seats.filter((s: number) => s !== seat);
                              handleCustomizeResult({ ...customizeResult, seat_capacity: newSeats });
                            }}>
                              {seat} Seats ×
                            </div>
                          ))}
                          {(customizeResult.priceRange?.min > filterCatalog.minPrice || (customizeResult.priceRange?.max > 0 && customizeResult.priceRange?.max < filterCatalog.maxPrice)) && (
                            <div className="home-results-chip" onClick={() => {
                              handleCustomizeResult({
                                ...customizeResult,
                                priceRange: { min: filterCatalog.minPrice, max: filterCatalog.maxPrice }
                              });
                            }}>
                              AED {customizeResult.priceRange.min} - {customizeResult.priceRange.max} (Daily) ×
                            </div>
                          )}
                          {(customizeResult.weeklyPriceRange?.min > filterCatalog.minWeeklyPrice || (customizeResult.weeklyPriceRange?.max > 0 && customizeResult.weeklyPriceRange?.max < filterCatalog.maxWeeklyPrice)) && (
                            <div className="home-results-chip" onClick={() => {
                              handleCustomizeResult({
                                ...customizeResult,
                                weeklyPriceRange: { min: filterCatalog.minWeeklyPrice, max: filterCatalog.maxWeeklyPrice }
                              });
                            }}>
                              AED {customizeResult.weeklyPriceRange.min} - {customizeResult.weeklyPriceRange.max} (Weekly) ×
                            </div>
                          )}
                          {(customizeResult.monthlyPriceRange?.min > filterCatalog.minMonthlyPrice || (customizeResult.monthlyPriceRange?.max > 0 && customizeResult.monthlyPriceRange?.max < filterCatalog.maxMonthlyPrice)) && (
                            <div className="home-results-chip" onClick={() => {
                              handleCustomizeResult({
                                ...customizeResult,
                                monthlyPriceRange: { min: filterCatalog.minMonthlyPrice, max: filterCatalog.maxMonthlyPrice }
                              });
                            }}>
                              AED {customizeResult.monthlyPriceRange.min} - {customizeResult.monthlyPriceRange.max} (Monthly) ×
                            </div>
                          )}
                          {customizeResult.isUnlimitedMileage && (
                            <div className="home-results-chip" onClick={() => {
                              handleCustomizeResult({ ...customizeResult, isUnlimitedMileage: false });
                            }}>
                              Unlimited Mileage ×
                            </div>
                          )}

                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Right Results Section */}
                <div className={isMobileView ? "col-12" : "col-md-9"}>
                  <div className={`row ${searchResultHeading ? "" : "d-none"}`}>
                    <div className="col-md-12 mb-3">
                      <div className="card custom-myAccount-card">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-12">
                              <p
                                className="dashboard-poppins-font-style mb-0"
                                style={{ fontSize: "13px", color: "white" }}
                              >
                                <strong>Disclaimer:</strong> Vehicle images are for
                                illustrative purposes only. The actual make, model,
                                color, and specifications of the vehicle you receive
                                may vary depending on availability at the time of
                                rental.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`row g-4 home-search-min-height align-content-start`}>
                    {isLoading || handleSearch.isPending ? (
                      <PageLoader />
                    ) : (
                      <>
                        {/* Applied Filters Chips */}
                        {!isMobileView && customizeResult && (
                          <div className="col-12 mb-3">
                            <div className="home-results-applied">
                              <span className="home-results-applied__label">Applied:</span>
                              <div className="home-results-applied__list">
                                {customizeResult.selectedCarTypes?.map((type: string) => (
                                  <div key={type} className="home-results-chip">
                                    {type}
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      const newTypes = customizeResult.selectedCarTypes.filter((t: string) => t !== type);
                                      handleCustomizeResult({ ...customizeResult, selectedCarTypes: newTypes });
                                    }}>×</span>
                                  </div>
                                ))}
                                {customizeResult.selectedBrands?.map((brand: string) => (
                                  <div key={brand} className="home-results-chip">
                                    {brand}
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      const newBrands = customizeResult.selectedBrands.filter((b: string) => b !== brand);
                                      handleCustomizeResult({ ...customizeResult, selectedBrands: newBrands });
                                    }}>×</span>
                                  </div>
                                ))}
                                {customizeResult.selectedFuelTypes?.map((fuel: string) => (
                                  <div key={fuel} className="home-results-chip">
                                    {fuel}
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      const newFuels = customizeResult.selectedFuelTypes.filter((f: string) => f !== fuel);
                                      handleCustomizeResult({ ...customizeResult, selectedFuelTypes: newFuels });
                                    }}>×</span>
                                  </div>
                                ))}
                                {customizeResult.selectedTransmissions?.map((trans: string) => (
                                  <div key={trans} className="home-results-chip">
                                    {trans}
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      const newTrans = customizeResult.selectedTransmissions.filter((t: string) => t !== trans);
                                      handleCustomizeResult({ ...customizeResult, selectedTransmissions: newTrans });
                                    }}>×</span>
                                  </div>
                                ))}
                                {customizeResult.seat_capacity && (Array.isArray(customizeResult.seat_capacity) ? customizeResult.seat_capacity : [customizeResult.seat_capacity]).map((seat: number) => (
                                  <div key={seat} className="home-results-chip">
                                    {seat} Seats
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      const seats = Array.isArray(customizeResult.seat_capacity) ? customizeResult.seat_capacity : [customizeResult.seat_capacity];
                                      const newSeats = seats.filter((s: number) => s !== seat);
                                      handleCustomizeResult({ ...customizeResult, seat_capacity: newSeats });
                                    }}>×</span>
                                  </div>
                                ))}
                                {(customizeResult.priceRange?.min > filterCatalog.minPrice || (customizeResult.priceRange?.max > 0 && customizeResult.priceRange?.max < filterCatalog.maxPrice)) && (
                                  <div className="home-results-chip">
                                    AED {customizeResult.priceRange.min} - {customizeResult.priceRange.max} (Daily)
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      handleCustomizeResult({
                                        ...customizeResult,
                                        priceRange: { min: filterCatalog.minPrice, max: filterCatalog.maxPrice }
                                      });
                                    }}>×</span>
                                  </div>
                                )}
                                {(customizeResult.weeklyPriceRange?.min > filterCatalog.minWeeklyPrice || (customizeResult.weeklyPriceRange?.max > 0 && customizeResult.weeklyPriceRange?.max < filterCatalog.maxWeeklyPrice)) && (
                                  <div className="home-results-chip">
                                    AED {customizeResult.weeklyPriceRange.min} - {customizeResult.weeklyPriceRange.max} (Weekly)
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      handleCustomizeResult({
                                        ...customizeResult,
                                        weeklyPriceRange: { min: filterCatalog.minWeeklyPrice, max: filterCatalog.maxWeeklyPrice }
                                      });
                                    }}>×</span>
                                  </div>
                                )}
                                {(customizeResult.monthlyPriceRange?.min > filterCatalog.minMonthlyPrice || (customizeResult.monthlyPriceRange?.max > 0 && customizeResult.monthlyPriceRange?.max < filterCatalog.maxMonthlyPrice)) && (
                                  <div className="home-results-chip">
                                    AED {customizeResult.monthlyPriceRange.min} - {customizeResult.monthlyPriceRange.max} (Monthly)
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      handleCustomizeResult({
                                        ...customizeResult,
                                        monthlyPriceRange: { min: filterCatalog.minMonthlyPrice, max: filterCatalog.maxMonthlyPrice }
                                      });
                                    }}>×</span>
                                  </div>
                                )}
                                {customizeResult.isUnlimitedMileage && (
                                  <div className="home-results-chip">
                                    Unlimited Mileage
                                    <span className="ms-2 cursor-pointer" onClick={() => {
                                      handleCustomizeResult({ ...customizeResult, isUnlimitedMileage: false });
                                    }}>×</span>
                                  </div>
                                )}
                                <button
                                  className="btn btn-link btn-sm text-decoration-none p-0 ms-2"
                                  style={{ color: '#F0B64F', fontSize: '12px', fontWeight: '600' }}
                                  onClick={() => handleCustomizeResult(null)}
                                >
                                  Clear All
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                        {filteredCars.length === 0 ? (
                          <div className="text-center">
                            <div>
                              <img
                                src={vector}
                                alt="Error Logo"
                                className="img-fluid"
                              />
                            </div>
                            <span style={{ color: "#eeeeee" }}>
                              No Car On The Searched Location
                            </span>
                          </div>
                        ) : (
                          filteredCars &&
                          filteredCars?.map((item: any, index: number) => (
                            <div
                              key={index}
                              className="col-sm-6 col-xl-6"
                            >
                              <div className="row h-100">
                                <div className="col-md-12 mx-auto">
                                  <div className="card card-custom-my-account h-100 mb-0">
                                    {/* <img
                        className="img-fluid search-result-image"
                        src={item?.product_details?.images[0]}
                        alt=""
                      /> */}
                                    <div
                                      className="position-relative"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedProduct(item);
                                        setShowDetailsModal(true);
                                        TagManager.dataLayer({
                                          dataLayer: {
                                            event: "car_detail_view",
                                            page_type: "product_listing",
                                            page_path: window.location.pathname,
                                            page_url: window.location.href,
                                            product_id: item?.product_id,
                                            product_name: item?.product_name,
                                            car_brand: item?.product_details_car?.car_brand,
                                            price_per_day: item?.product_details_car?.price_per_day,
                                          }
                                        });
                                      }}>
                                      {item?.product_details?.images?.length > 0 ? (
                                        <img
                                          className="img-fluid search-result-image"
                                          src={item?.product_details?.images?.[0]}
                                          alt=""
                                        />
                                      ) : (
                                        <img
                                          src={noun_no_image}
                                          alt=""
                                          className="img-fluid search-result-image"
                                        />
                                      )}
                                      {/* Glassmorphic overlay for tags */}
                                      {item?.tags && Array.isArray(item.tags) && item.tags.length > 0 && (
                                        <div
                                          className="position-absolute d-flex flex-wrap gap-1"
                                          style={{
                                            top: "10px",
                                            left: "10px",
                                            zIndex: 10,
                                            pointerEvents: "none"
                                          }}
                                        >
                                          {item.tags.map((tag: string, tagIdx: number) => {
                                            const tagLower = tag.toLowerCase();
                                            let style: React.CSSProperties = {
                                              fontSize: "0.6rem",
                                              fontFamily: "Poppins, sans-serif",
                                              fontWeight: 800,
                                              textTransform: "uppercase",
                                              letterSpacing: "0.7px",
                                              padding: "0.2rem 0.6rem",
                                              borderRadius: "6px",
                                              backdropFilter: "blur(6px)",
                                              lineHeight: 1.5,
                                              whiteSpace: "nowrap",
                                              // default (fallback)
                                              background: "rgba(18, 21, 28, 0.85)",
                                              color: "#f0b64f",
                                              border: "1px solid rgba(240, 182, 79, 0.5)",
                                              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                                            };

                                            return (
                                              <span
                                                key={`${tag}-${tagIdx}`}
                                                style={style}
                                              >
                                                {tag}
                                              </span>
                                            );
                                          })}
                                        </div>
                                      )}
                                    </div>
                                    <div className="card-body">
                                      <div className="row text-start">
                                        <div className="col-6">
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip id={`tooltip-cat-${index}`}>
                                                {item?.product_name}
                                              </Tooltip>
                                            }
                                          >
                                            <div className="car-cat-search ">
                                              {item?.product_name}
                                            </div>
                                          </OverlayTrigger>

                                          <OverlayTrigger
                                            placement="top"
                                            overlay={
                                              <Tooltip id={`tooltip-name-${index}`}>
                                                {item?.product_name}
                                              </Tooltip>
                                            }
                                          >
                                            <div className="car-name-search">
                                              {item?.product_name}
                                            </div>
                                          </OverlayTrigger>
                                        </div>
                                        <div className="col-6">
                                          <div className="text-center merchant-name-div mx-2 mb-1">
                                            <span>
                                              {" "}
                                              {item?.site_logo ? (
                                                <img
                                                  className="img-fluid logo-merchant"
                                                  src={item?.site_logo}
                                                  alt=""
                                                />
                                              ) : (
                                                <span title={item?.shop_name}>
                                                  {String(item?.shop_name).length >
                                                    10
                                                    ? `${String(item?.shop_name)
                                                      .substring(0, 10)
                                                      .toUpperCase()}...`
                                                    : String(
                                                      item?.shop_name,
                                                    ).toUpperCase()}
                                                </span>
                                              )}
                                            </span>
                                          </div>
                                          <div className="text-center mx-2">
                                            <div className="merchant-name-container font-size-home-12" title={item?.shop_name}>
                                              {item?.shop_name}
                                            </div>
                                          </div>
                                          {/* <div className="text-center pt-2">
                                        <StarFill color={"#F0B64F"} size={12} />
                                        <span className="ps-2">
                                          <StarFill
                                            color={"#F0B64F"}
                                            size={12}
                                          />
                                        </span>
                                        <span className="ps-2">
                                          <StarFill
                                            color={"#F0B64F"}
                                            size={12}
                                          />
                                        </span>
                                        <span className="ps-2">
                                          <StarFill
                                            color={"#F0B64F"}
                                            size={12}
                                          />
                                        </span>
                                        <span className="ps-2">
                                          <StarFill
                                            color={"#F0B64F"}
                                            size={12}
                                          />
                                        </span>
                                      </div> */}
                                        </div>
                                      </div>
                                      <div className="row pt-2 search-features align-items-center">
                                        <div className="col-6">
                                          <div className="col-md-12 text-start  pb-2 dashboard-poppins-font-style  car-name-search-bold">
                                            Features
                                          </div>
                                          <div className="d-flex">
                                            <div className="text-start dashboard-poppins-font-style me-2">
                                              <img
                                                src={group_icon}
                                                alt=""
                                                className="img-fluid img-width-icon"
                                              />
                                              &nbsp;
                                              {
                                                item?.product_details_car
                                                  ?.number_of_seats
                                              }
                                            </div>
                                            <div className="text-start dashboard-poppins-font-style">
                                              <img
                                                src={petrol_pump}
                                                alt=""
                                                className="img-fluid img-width-icon"
                                              />
                                              &nbsp;
                                              {item?.product_details_car?.fuel_type}
                                            </div>
                                          </div>
                                          {/* <div className="col-md-12 text-start pt-1 ">
                                    <img
                                      src={mileage}
                                      alt="file_browse_icon"
                                      className="img-fluid img-width-icon"
                                      style={{ alignItems: "left" }}
                                    />
                                    <span className="px-1 dashboard-poppins-font-style">
                                      Unlimited Mileage
                                    </span>
                                  </div> */}
                                        </div>
                                        <div className="col-6">
                                          <div className="search-car-special-deal text-center">
                                            <img
                                              src={dashboard_special_deal}
                                              alt=""
                                              width={13}
                                              className=""
                                            />
                                            <span className="dashboard-poppins-font-style">
                                              {" "}
                                              Special Deal{" "}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      {/* <div className="row pt-2">
                                    <div className="col-12">
                                      <div className="text-start dashboard-poppins-font-style font-size-home-12">
                                        {item?.product_details_car
                                          ?.description || " "}
                                      </div>
                                    </div>
                                  </div> */}
                                      {/* <div className="row search-features">
                                <div className="col-md-12 text-start pt-1 ">
                                  <img
                                    src={mileage}
                                    alt="file_browse_icon"
                                    className="img-fluid img-width-icon"
                                    style={{ alignItems: "left" }}
                                  />
                                  <span className="px-1 dashboard-poppins-font-style">
                                    Unlimited Mileage
                                  </span>
                                </div>
                              </div> */}
                                      <div className="row text-start pt-2">
                                        <div className="col-4">
                                          <div className="font-size-home-14 dashboard-poppins-font-style">
                                            AED{" "}
                                            <span>
                                              {
                                                item.product_details_car
                                                  .price_per_day
                                              }
                                            </span>
                                          </div>
                                          <div className=" car-name-search-bold dashboard-poppins-font-style">
                                            Per Day
                                          </div>
                                          <div className="car-name-search-bold dashboard-poppins-font-style">
                                            {item?.product_details_car?.mileage
                                              ?.daily_mileage ? (
                                              `${item.product_details_car.mileage.daily_mileage} KM`
                                            ) : (
                                              <div className="car-name-search dashboard-poppins-font-style">
                                                {" "}
                                                Unlimited mileage{" "}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-4">
                                          <div className="font-size-home-14 dashboard-poppins-font-style">
                                            AED{" "}
                                            <span>
                                              {
                                                item.product_details_car
                                                  .price_per_week
                                              }
                                            </span>
                                          </div>
                                          <div className="car-name-search dashboard-poppins-font-style">
                                            Per Week
                                          </div>
                                          <div className="car-name-search-bold dashboard-poppins-font-style">
                                            {item?.product_details_car?.mileage
                                              ?.weekly_mileage ? (
                                              `${item.product_details_car.mileage.weekly_mileage} KM`
                                            ) : (
                                              <div className="car-name-search dashboard-poppins-font-style">
                                                {" "}
                                                Unlimited mileage{" "}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                        <div className="col-4">
                                          <div className="font-size-home-14 dashboard-poppins-font-style">
                                            AED{" "}
                                            <span>
                                              {
                                                item.product_details_car
                                                  .price_per_month
                                              }
                                            </span>
                                          </div>
                                          <div className="car-name-search dashboard-poppins-font-style">
                                            Per Month
                                          </div>
                                          <div className="car-name-search-bold dashboard-poppins-font-style">
                                            {item?.product_details_car?.mileage
                                              ?.monthly_mileage ? (
                                              `${item.product_details_car.mileage.monthly_mileage} KM`
                                            ) : (
                                              <div className="car-name-search dashboard-poppins-font-style">
                                                {" "}
                                                Unlimited mileage{" "}
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="row pt-2">
                                        <div className="col-md-12 d-flex justify-content-between align-items-center">
                                          <a
                                            href="#"
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setSelectedProduct(item);
                                              setShowDetailsModal(true);
                                              TagManager.dataLayer({
                                                dataLayer: {
                                                  event: "car_detail_view",
                                                  page_type: "product_listing",
                                                  page_path: window.location.pathname,
                                                  page_url: window.location.href,
                                                  product_id: item?.product_id,
                                                  product_name: item?.product_name,
                                                  car_brand: item?.product_details_car?.car_brand,
                                                  price_per_day: item?.product_details_car?.price_per_day,
                                                }
                                              });
                                            }}
                                            style={{
                                              fontSize: "0.85rem",
                                              textDecoration: "underline",
                                              cursor: "pointer",
                                              color: "#F0B64F",
                                            }}
                                          >
                                            VIEW DETAILS
                                          </a>
                                          <button
                                            className="book-now-button-style "
                                            onClick={() => {
                                              handleBookingClick(item.product_id);
                                              setSelectProductId(item.product_id);
                                            }}
                                          >
                                            BOOK NOW
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))
                        )}

                        {/* ---------------------  search mapping end ----------------------- */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {showUpgradeModal && <UpgradeModal />}
          </div>
          {/* -------------------------------------- search result end ------------------------------- */}
          {/* ---------------------------- working start --------------------------------- */}
          {!isMobileView && <CustomerDashBoardHowItWorks />}
          {/* ---------------------------- working end --------------------------------- */}
          {/* ----------------- Reviews ---------------------------------------- */}
          {/* {!isMobileView && <MerchantDashboardReviews />} */}
          {/* ------------------------- review -----------------------------  */}
        </div>

        {/* Modal version for mobile view */}
        {isMobileView && (
          <CustomerCustomizeYourSearch
            isOpen={showCreateProduct}
            onClose={() => setShowCreateProduct(false)}
            onCustomizeResult={(res: any) => {
              setCarName(res.product_name || "");
              handleCustomizeResult(res);
            }}
            initialValues={{
              ...customizeResult,
              product_name: carName || customizeResult?.product_name || "",
            }}
            filterCatalog={filterCatalog}
            totalCars={searchCars}
          />
        )}

        {/* Map Modals */}
        <LocationPickerModal
          isOpen={showPickupMapModal}
          onClose={() => setShowPickupMapModal(false)}
          onLocationSelect={handlePickupMapSelect}
          onSameAsContactAddress={handleSameAsContactAddress}
          initialLocation={
            pickupLocation.latitude !== null &&
              pickupLocation.longitude !== null
              ? {
                latitude: pickupLocation.latitude as number,
                longitude: pickupLocation.longitude as number,
              }
              : { latitude: 25.1972, longitude: 55.2744 }
          }
          initialAddress={searchValues.pickup}
          title="Select Pick Up Location"
        />

        <LocationPickerModal
          isOpen={showReturnMapModal}
          onClose={() => setShowReturnMapModal(false)}
          onLocationSelect={handleReturnMapSelect}
          onSameAsContactAddress={handleSameAsContactAddress}
          initialLocation={
            returnLocation.latitude !== null &&
              returnLocation.longitude !== null
              ? {
                latitude: returnLocation.latitude as number,
                longitude: returnLocation.longitude as number,
              }
              : pickupLocation.latitude !== null &&
                pickupLocation.longitude !== null
                ? {
                  latitude: pickupLocation.latitude as number,
                  longitude: pickupLocation.longitude as number,
                }
                : { latitude: 25.1972, longitude: 55.2744 }
          }
          initialAddress={searchValues.return}
          title="Select Return Location"
          disableAutoSelectOnMount={!searchValues.return}
        />

        {/* Product Details Modal */}
        <Modal
          show={showDetailsModal}
          onHide={() => setShowDetailsModal(false)}
          size="lg"
          centered
        >
          <Modal.Header closeButton style={{ padding: "0.5rem 1rem" }}>
            <Modal.Title style={{ fontSize: "1rem" }}>
              {selectedProduct?.product_name?.toUpperCase() ||
                "Product Details"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "55vh", overflowY: "auto", padding: "0.75rem" }}>
            {selectedProduct && (
              <div className="container-fluid">
                <div className="row" style={{ marginBottom: 0 }}>
                  {/* Image Section */}
                  <div className="col-md-5" style={{ paddingBottom: 0 }}>
                    {selectedProduct?.product_details?.images?.length > 0 ? (
                      <img
                        className="img-fluid rounded"
                        src={selectedProduct?.product_details?.images?.[0]}
                        alt={selectedProduct?.product_name}
                        style={{
                          width: "100%",
                          maxHeight: "160px",
                          objectFit: "cover",
                        }}
                      />
                    ) : (
                      <img
                        src={noun_no_image}
                        alt="No image"
                        className="img-fluid rounded"
                        style={{
                          width: "100%",
                          maxHeight: "160px",
                          objectFit: "cover",
                        }}
                      />
                    )}
                    {selectedProduct?.product_details?.images?.length > 1 && (
                      <div className="d-flex flex-wrap gap-2 mt-2">
                        {selectedProduct.product_details.images
                          .slice(1, 5)
                          .map((img: string, idx: number) => (
                            <img
                              key={idx}
                              src={img}
                              alt={`Gallery ${idx + 1}`}
                              className="img-thumbnail"
                              style={{
                                width: "44px",
                                height: "44px",
                                objectFit: "cover",
                                cursor: "pointer",
                              }}
                            />
                          ))}
                      </div>
                    )}
                  </div>

                  {/* Details Section */}
                  <div className="col-md-7" style={{ paddingBottom: 0 }}>
                    {/* Merchant & Logo */}
                    <div className="mb-3 pb-2 border-bottom">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <div className="fw-bold ">
                            {selectedProduct?.shop_name || "N/A"}
                          </div>
                        </div>
                        {selectedProduct?.site_logo && (
                          <div className="text-end">
                            <img
                              src={selectedProduct.site_logo}
                              alt={
                                selectedProduct?.shop_name || "Merchant Logo"
                              }
                              style={{
                                maxHeight: "36px",
                                maxWidth: "90px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Vehicle Specifications */}
                    <div className="mb-3">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", fontWeight: "600" }}
                      >
                        Vehicle Specifications
                      </h6>
                      <div className="row g-1" style={{ fontSize: "0.75rem" }}>
                        {selectedProduct?.product_details_car?.car_type && (
                          <div className="col-6">
                            <strong>Type:</strong>{" "}
                            {selectedProduct.product_details_car.car_type}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.model_year && (
                          <div className="col-6">
                            <strong>Year:</strong>{" "}
                            {selectedProduct.product_details_car.model_year}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.transmission && (
                          <div className="col-6">
                            <strong>Transmission:</strong>{" "}
                            {selectedProduct.product_details_car.transmission}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.fuel_type && (
                          <div className="col-6">
                            <strong>Fuel:</strong>{" "}
                            {selectedProduct.product_details_car.fuel_type}
                          </div>
                        )}
                        {selectedProduct?.product_details_car
                          ?.number_of_seats && (
                            <div className="col-6">
                              <strong>Seats:</strong>{" "}
                              {
                                selectedProduct.product_details_car
                                  .number_of_seats
                              }
                            </div>
                          )}
                        {selectedProduct?.product_details_car
                          ?.number_of_doors && (
                            <div className="col-6">
                              <strong>Doors:</strong>{" "}
                              {
                                selectedProduct.product_details_car
                                  .number_of_doors
                              }
                            </div>
                          )}
                        {selectedProduct?.product_details_car?.car_color && (
                          <div className="col-6">
                            <strong>Color:</strong>{" "}
                            {selectedProduct.product_details_car.car_color}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.sipp && (
                          <div className="col-6">
                            <strong>SIPP Code:</strong>{" "}
                            {selectedProduct.product_details_car.sipp}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.engine_type && (
                          <div className="col-6">
                            <strong>Engine:</strong>{" "}
                            {selectedProduct.product_details_car.engine_type}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.max_power && (
                          <div className="col-6">
                            <strong>Power:</strong>{" "}
                            {selectedProduct.product_details_car.max_power}
                          </div>
                        )}
                        {selectedProduct?.product_details_car?.deposit > 0 && (
                          <div className="col-6">
                            <strong>Deposit:</strong> AED{" "}
                            {selectedProduct.product_details_car.deposit}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Features and Description Row */}
                <div className="row" style={{ marginTop: 0, marginBottom: 0 }}>
                  <div className="col-md-6">

                    {/* Description */}
                    {selectedProduct?.product_details_car?.description && (
                      <div className="mb-3">
                        <h6
                          className="mb-1"
                          style={{ fontSize: "0.8rem", fontWeight: "600" }}
                        >
                          Description
                        </h6>
                        <p style={{ fontSize: "0.75rem", marginBottom: 0 }}>
                          {selectedProduct.product_details_car.description}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <h6
                        className="mb-1"
                        style={{ fontSize: "0.8rem", fontWeight: "600" }}
                      >
                        Features
                      </h6>
                      <div
                        className="d-flex flex-wrap gap-1"
                        style={{ fontSize: "0.72rem" }}
                      >
                        {selectedProduct?.product_details_car?.ac && (
                          <span className="badge bg-light text-dark border">
                            AC
                          </span>
                        )}
                        {selectedProduct?.product_details_car
                          ?.cruise_control && (
                            <span className="badge bg-light text-dark border">
                              Cruise Control
                            </span>
                          )}
                        {selectedProduct?.product_details_car
                          ?.key_less_entry && (
                            <span className="badge bg-light text-dark border">
                              Keyless Entry
                            </span>
                          )}
                        {selectedProduct?.product_details_car?.abs_break && (
                          <span className="badge bg-light text-dark border">
                            ABS
                          </span>
                        )}
                        {selectedProduct?.product_details_car?.buletooth && (
                          <span className="badge bg-light text-dark border">
                            Bluetooth
                          </span>
                        )}
                        {selectedProduct?.product_details_car
                          ?.duel_front_air_bag && (
                            <span className="badge bg-light text-dark border">
                              Dual Airbags
                            </span>
                          )}
                      </div>
                    </div>
                  </div>

                </div>

                {/* Pricing Section */}
                <div
                  className="row"
                  style={{
                    backgroundColor: "#000",
                    marginLeft: "-12px",
                    marginRight: "-12px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    paddingTop: "1rem",
                    paddingBottom: "1rem",
                    marginTop: 0,
                  }}
                >
                  <div className="col-12 mb-1">
                    <h6
                      style={{
                        fontSize: "0.8rem",
                        fontWeight: "600",
                        color: "#fff",
                        marginBottom: 0,
                      }}
                    >
                      Pricing & Mileage
                    </h6>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      className="card border"
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "#000",
                        borderColor: "#333",
                      }}
                    >
                      <div
                        className="text-center"
                        style={{ padding: "0.5rem" }}
                      >
                        <div className="fw-bold" style={{ color: "#fff" }}>
                          Per Day
                        </div>
                        <div
                          className="fw-bold"
                          style={{ fontSize: "1.1rem", color: "#F0B64F" }}
                        >
                          AED{" "}
                          {selectedProduct?.product_details_car
                            ?.price_per_day || "0"}
                        </div>
                        <small style={{ color: "#aaa" }}>
                          {selectedProduct?.product_details_car?.mileage
                            ?.daily_mileage
                            ? `${selectedProduct.product_details_car.mileage.daily_mileage} KM/day`
                            : "Unlimited mileage"}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      className="card border"
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "#000",
                        borderColor: "#333",
                      }}
                    >
                      <div
                        className="text-center"
                        style={{ padding: "0.5rem" }}
                      >
                        <div className="fw-bold" style={{ color: "#fff" }}>
                          Per Week
                        </div>
                        <div
                          className="fw-bold"
                          style={{ fontSize: "1.1rem", color: "#F0B64F" }}
                        >
                          AED{" "}
                          {selectedProduct?.product_details_car
                            ?.price_per_week || "0"}
                        </div>
                        <small style={{ color: "#aaa" }}>
                          {selectedProduct?.product_details_car?.mileage
                            ?.weekly_mileage
                            ? `${selectedProduct.product_details_car.mileage.weekly_mileage} KM/week`
                            : "Unlimited mileage"}
                        </small>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 mb-2">
                    <div
                      className="card border"
                      style={{
                        fontSize: "0.85rem",
                        backgroundColor: "#000",
                        borderColor: "#333",
                      }}
                    >
                      <div
                        className="text-center"
                        style={{ padding: "0.5rem" }}
                      >
                        <div className="fw-bold" style={{ color: "#fff" }}>
                          Per Month
                        </div>
                        <div
                          className="fw-bold"
                          style={{ fontSize: "1.1rem", color: "#F0B64F" }}
                        >
                          AED{" "}
                          {selectedProduct?.product_details_car
                            ?.price_per_month || "0"}
                        </div>
                        <small style={{ color: "#aaa" }}>
                          {selectedProduct?.product_details_car?.mileage
                            ?.monthly_mileage
                            ? `${selectedProduct.product_details_car.mileage.monthly_mileage} KM/month`
                            : "Unlimited mileage"}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer style={{ padding: "0.4rem 0.75rem" }}>
            <button
              className="btn btn-secondary btn-sm"
              onClick={() => setShowDetailsModal(false)}
            >
              Close
            </button>
            <button
              className="book-now-button-style"
              onClick={() => {
                if (selectedProduct) {
                  handleBookingClick(selectedProduct.product_id);
                  setSelectProductId(selectedProduct.product_id);
                  setShowDetailsModal(false);
                }
              }}
            >
              BOOK NOW
            </button>
          </Modal.Footer>
        </Modal>

        {/* Logout Confirmation Modal */}
        <Modal
          show={showLogoutModal}
          onHide={handleCancelLogout}
          centered
          backdrop="static"
        >
          <Modal.Header>
            <Modal.Title>Confirm Logout</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to logout?</p>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={handleCancelLogout}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleLogout}
            >
              Logout
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default CustomerDashBoardMyAccount;
